module.exports = __webpack_public_path__ + "static/media/senf8.7cfb49f0.png";